import { Icon, IconName } from '@openeducation/oe-rn-components';
import React from 'react';

import { useColors } from '../../../hooks';
import { mediaQueryValues } from '../../media-query';

interface IconPlayerButtonProps {
  iconName: IconName;
  colors?;
  size?;
}

export function IconPlayerButton({
  iconName,
  size = 'medium',
  colors = 'onPrimary',
}: IconPlayerButtonProps) {
  const color = useColors();
  const mediaQuery = mediaQueryValues();
  return (
    <Icon
      color={color[colors]}
      size={mediaQuery[size]}
      name={iconName}
      type="solid"
    />
  );
}
